import React from "react";
import { Box, Tooltip } from "@mui/material";
import { tokens } from "./tokens";

/**
 * Code Chip (§5.4) — chip mono para códigos clínicos: ICD-10, CPT, HCC, CIP_ID.
 * Borde fino, fondo surface-2, fuente mono. El valor crudo se conserva en
 * `raw` (tooltip) cuando se muestra formateado.
 *
 * @param {string} code        - texto a mostrar (ej. "E11.9", "99214", "HCC 19")
 * @param {string} [raw]       - valor crudo original (se muestra en tooltip)
 * @param {"ok"|"warn"|"crit"|"info"} [tone] - acento opcional de borde
 */
export default function CodeChip({ code, raw, tone, sx }) {
  const accent =
    tone === "ok" ? tokens.ok :
    tone === "warn" ? tokens.warn :
    tone === "crit" ? tokens.crit :
    tone === "info" ? tokens.info : tokens.line;

  const chip = (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 0.8,
        py: "1px",
        border: `1px solid ${accent}`,
        borderRadius: "4px",
        bgcolor: tokens.surface2,
        fontFamily: tokens.fontMono,
        fontSize: 12,
        color: tokens.ink,
        whiteSpace: "nowrap",
        lineHeight: 1.7,
        ...sx,
      }}
    >
      {code}
    </Box>
  );
  return raw && raw !== code ? (
    <Tooltip title={`Raw value: ${raw}`} arrow>{chip}</Tooltip>
  ) : chip;
}
